import React, { useEffect } from "react";
import { appConfig } from "../../../configApp";

const DeceasedPeople = () => {

    useEffect(() => {
        window.location.href = appConfig?.baseUrlDeceased
    }, []);

    return null; 
};

export default DeceasedPeople;